(() => {
  const addMobileLayoutGuard = () => {
    if (document.getElementById('BloomMobileFacetLayout')) return;
    const style = document.createElement('style');
    style.id = 'BloomMobileFacetLayout';
    style.textContent = `
      @media screen and (max-width: 767px) {
        #FacetDrawerSticky .drawer__inner { width: 100vw; max-width: 100vw; }
        #FacetDrawerSticky .drawer__content { min-height: 0; }
        #FacetDrawerSticky .drawer__scrollable {
          min-height: 0;
          overflow-y: auto;
          overscroll-behavior: contain;
          padding-bottom: calc(88px + env(safe-area-inset-bottom, 0px));
        }
        #FacetDrawerSticky .drawer__sticky {
          background: rgb(var(--color-background));
          padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
        }
      }
    `;
    document.head.appendChild(style);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addMobileLayoutGuard, { once: true });
  } else {
    addMobileLayoutGuard();
  }
})();